import { Group, Text } from '@mantine/core';

export function Rows({
  items,
}: {
  items: { label: string; value: React.ReactNode }[];
}) {
  return items.map((item) => {
    return (
      <Group key={item.label} justify="space-between">
        <Text c="var(--mantine-color-main-2)">{item.label}:</Text>
        <Text>{item.value}</Text>
      </Group>
    );
  });
}
